// src/app/core/guards/health.guard.ts

import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the entire `/health` section.
 *
 * Requires the dedicated `claims.health.view_cards` portal permission.
 * `admin.full_access` bypasses the check via PermissionService.has.
 */
export const healthGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewHealthCards(), '/dashboard');
};

/**
 * CanActivateFn — gates `/health/cards` card-lookup page explicitly.
 * Kept separate so future `/health/*` pages can opt into their own checks.
 */
export const healthCardsGuard: CanActivateFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewHealthCards(), '/dashboard');
};
